import OrderHistoryLayout from "@/core/layout/orderHistory/orderHistory.layout.tsx"

const OrderHistoryPage = () => {
    return <OrderHistoryLayout />
}

export default OrderHistoryPage

